var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full master-container text-chplus-regular flex flex-col items-center"},[_c('div',{staticClass:"hidden lg:flex w-full"},[(!_vm.hideTopBar)?_c('LargeDisplayNavbar'):_vm._e()],1),_c('div',{class:`master-container-content min-h-0 relative w-full flex flex-col flex-grow ${_vm.contentClass}`,style:({
      paddingTop: _vm.paddingTop ? null : 0,
      paddingRight: _vm.paddingRight ? null : 0,
      paddingBottom: _vm.paddingBottom ? null : 0,
      paddingLeft: _vm.paddingLeft ? null : 0
    })},[_c('div',{staticClass:"flex flex-col flex-grow min-h-0"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }